import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const CtaBanner = () => {
  return (
    <BannerSection>
      <BannerInner>
        <BannerText>
          <BannerTitle>Ready to Start Your Project?</BannerTitle>
          <BannerSub>
            Contact us today for a free consultation and let us bring your vision to life.
          </BannerSub>
        </BannerText>
        <BannerActions>
          <PrimaryBtn as={Link} to="/contact">Get a Free Quote</PrimaryBtn>
          <PhoneBtn href="tel:+18188095041">1 (818) 809-5041</PhoneBtn>
        </BannerActions>
      </BannerInner>
    </BannerSection>
  );
};

const BannerSection = styled.section`
  background: #111827;
  padding: 72px 32px;
  @media (max-width: 768px) {
    padding: 52px 20px;
  }
`;

const BannerInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 32px;
  }
`;

const BannerText = styled.div``;

const BannerTitle = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1.5rem, 2.5vw, 2rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
`;

const BannerSub = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  color: #9ca3af;
  line-height: 1.6;
`;

const BannerActions = styled.div`
  display: flex;
  gap: 16px;
  flex-shrink: 0;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const PrimaryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  background: #c89432;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 4px;
  border: 2px solid #c89432;
  transition: background 0.25s ease, transform 0.2s ease;
  white-space: nowrap;
  &:hover {
    background: #a97a20;
    border-color: #a97a20;
    transform: translateY(-2px);
  }
`;

const PhoneBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  background: transparent;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  transition: border-color 0.25s ease, background 0.25s ease, transform 0.2s ease;
  white-space: nowrap;
  &:hover {
    border-color: #fff;
    background: rgba(255, 255, 255, 0.08);
    transform: translateY(-2px);
  }
`;

export default CtaBanner;
